import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';

const DatePickerDay = generatePicker(dayjsGenerateConfig);

export default DatePickerDay;
